/*
  dd-event-xsell-toolkit.js

  Keeps the standalone "event toolkit" cross-sell card in sync with the ticket's
  Toolkit option so it never double-charges. The card is server-rendered in the
  correct initial state (see sections/dd-event-xsell.liquid); this only reacts to
  the buyer switching the seat's Toolkit variant:

    • "With Toolkit" seat  -> card shows an "Included with your ticket" confirmation
      (buy button hidden via .is--included in dd-event-xsell.css).
    • "Without Toolkit" seat -> card shows the normal Add to cart.

  Toolkit detection is delegated to the canonical helper window.DDEventIdentity
  (assets/dd-event-identity.js, loaded before this file in dd-event-xsell.liquid),
  so the "With/Without Toolkit" rule lives in ONE place. Zero added Shopify
  requests: it only listens to Dawn's in-page variantChange pub/sub.
*/
(function () {
  'use strict';

  var card = document.querySelector('[data-dd-event-toolkit-card]');
  if (!card) return;

  function isWithToolkit(variant) {
    if (window.DDEventIdentity) {
      return window.DDEventIdentity.isWithToolkitVariant(variant);
    }
    /* Fallback if the helper failed to load. */
    if (!variant) return false;
    var parts = [];
    if (variant.title) parts.push(variant.title);
    if (variant.options && variant.options.length) {
      parts = parts.concat(variant.options);
    }
    var s = parts.join(' ').toLowerCase();
    if (s.indexOf('toolkit') === -1) return false;
    if (s.indexOf('without toolkit') !== -1) return false;
    if (s.indexOf('bring your own') !== -1) return false;
    return true;
  }

  function apply(withToolkit) {
    card.classList.toggle('is--included', !!withToolkit);
  }

  // Safety net: reconcile against the ticket's currently selected variant on
  // load, in case the server class and client disagree. The only <variant-selects>
  // on this PDP is the ticket's (cross-sell cards don't render one).
  try {
    var script = document.querySelector('variant-selects script[data-selected-variant]');
    if (script && script.textContent) {
      apply(isWithToolkit(JSON.parse(script.textContent)));
    }
  } catch (err) {
    /* leave the server-rendered state as-is */
  }

  if (
    typeof subscribe !== 'undefined' &&
    typeof PUB_SUB_EVENTS !== 'undefined' &&
    PUB_SUB_EVENTS.variantChange
  ) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var variant = event && event.data && event.data.variant;
      if (typeof variant === 'undefined') return;
      try {
        apply(isWithToolkit(variant));
      } catch (err) {
        console.error('[dd-event-xsell-toolkit] state update failed', err);
      }
    });
  }
})();
